/** Shared application constants */

/** Auto-save draft interval in milliseconds (30 seconds) */
export const AUTO_SAVE_INTERVAL_MS = 30000;

/** Dashboard refresh interval in milliseconds (30 seconds) */
export const DASHBOARD_REFRESH_MS = 30000;
